<div class="app-main__inner">

  <!-- ── Toolbar ────────────────────────────────────────────────────────────── -->
  <div class="rpr-toolbar">
    <span class="small text-muted me-1">Closed:</span>
    <div class="rpr-presets">
      <button class="rpr-preset-btn" [class.active]="preset === 'all'"    (click)="setPreset('all')">All Time</button>
      <button class="rpr-preset-btn" [class.active]="preset === 'month'"  (click)="setPreset('month')">This Month</button>
      <button class="rpr-preset-btn" [class.active]="preset === 'year'"   (click)="setPreset('year')">This Year</button>
      <button class="rpr-preset-btn" [class.active]="preset === 'custom'" (click)="setPreset('custom')">Custom</button>
    </div>
    <ng-container *ngIf="preset === 'custom'">
      <input type="date" class="form-control form-control-sm rpr-tb-date" [(ngModel)]="customFrom" />
      <span class="rpr-tb-sep">to</span>
      <input type="date" class="form-control form-control-sm rpr-tb-date" [(ngModel)]="customTo" />
      <button class="btn btn-primary btn-sm rpr-go-btn" (click)="applyFilters()">Go</button>
    </ng-container>
    <button class="btn btn-outline-secondary btn-sm ms-auto" (click)="load()" [disabled]="loading" title="Reload">
      <i class="pe-7s-refresh-2"></i>
    </button>
  </div>

  <div *ngIf="error" class="alert alert-danger py-2 mb-2">{{ error }}</div>

  <div *ngIf="loading" class="rpr-loading">
    <div class="spinner-border text-primary"></div>
    <span>Loading closed members...</span>
  </div>

  <ng-container *ngIf="loaded && !loading">

    <div *ngIf="records.length" class="d-flex flex-wrap align-items-center gap-3 mb-2 small">
      <span><span class="text-muted">Closed members:</span> <strong>{{ records.length }}</strong></span>
      <span><span class="text-muted">Total deposit refunded:</span> <strong>₹{{ totalRefunded | number:'1.0-2' }}</strong></span>
    </div>

    <div *ngIf="!records.length" class="rpr-empty">No closed memberships found for the selected period.</div>
    <vio-table-v2 *ngIf="records.length" [tableData]="records" [tableConfig]="tableConfig"></vio-table-v2>
  </ng-container>

</div>
